import React from 'react';

const Payments = () => {
  return <div>Admin Payments</div>;
};

export default Payments; 